import { AxiosResponse } from 'axios'
import securityService from '../services/securityService'
const users = {
	state: {
		previousUser: '',
		currentUser: {},
		woningAccordingID: '',
		perceelAccordingID: ''
	},
	getters: {
		getWoningAccordingID: (state: { woningAccordingID: any }) => {
			return state.woningAccordingID
		},
		getPerceelAccordingID: (state: { perceelAccordingID: any }) => {
			return state.perceelAccordingID
		},
		getCurrentUser: (state: { currentUser: any }) => {
			return state.currentUser
		},
		isLoggedIn: (state: { currentUser: { accessToken: any } }) => {
			return !state.currentUser.accessToken === false
		},
		accessToken: (state: { currentUser: { accessToken: any } }) => {
			return state.currentUser.accessToken
		}
	},
	mutations: {
		setWoningAccordingID: (state: { woningAccordingID: any }, id: any) => {
			state.woningAccordingID = id
		},
		setPerceelAccordingID: (state: { perceelAccordingID: any }, id: any) => {
			state.perceelAccordingID = id
		},
		setPreviousUser: (state: { previousUser: any }, user: any) => {
			state.previousUser = user
		},
		setCurrentUser: (state: { currentUser: any }, user: any) => {
			state.currentUser = user
		},
		setTempUser: (state: { tempUser: any }, user: any) => {
			state.tempUser = user
		}
	},
	actions: {
		authenticateLogin({ commit }: any, credentials: { username: any; password: any }) {
			const data = securityService.authenticateLogin(credentials.username, credentials.password)

			return Promise.resolve(data).then(function (
				value: { status: number; data: any },
				reject: (arg0: Promise<AxiosResponse<any, any> | ''>) => void
			) {
				if (value.status === 200 && value && value.data) {
					commit('setTempUser', value.data)
				} else {
					reject(data)
				}
			}, null)
		},
		authenticateTotp({ commit, state }: any, rawdata: { token: any; code: any; mode: any }) {
			const data = securityService.authenticateTotp(rawdata.token, rawdata.code, rawdata.mode)

			return Promise.resolve(data).then(function (
				value: { status: number; data: { accessToken: any } },
				reject: (arg0: Promise<AxiosResponse<any, any> | ''>) => void
			) {
				if (value.status === 200 && value && value.data && value.data.accessToken) {
					const user = state.tempUser
					const target_copy = Object.assign({}, user)
					target_copy.accessToken = value.data.accessToken
					target_copy.loginToken = ''
					commit('setCurrentUser', target_copy)
					commit('setTempUser', {})
				} else {
					reject(data)
				}
			}, null)
		}
	}
}

export default users
